export default "__VITE_ASSET__NHj6gPAH__"